import React, {ReactNode, useEffect, useMemo} from 'react';
import {createPortal} from "react-dom";
import Modal from "../components/Utils/Modal/Modal";
import {EnumFog} from "../components/Utils/FogContainer/FogContainer";

const modalRootElement = document.getElementById('modal')

interface IModalPortalProps {
    children: ReactNode,
    options: {
        setStateModal: (boolean: boolean) => void,
        statusModal: boolean,
        fogPower: EnumFog
    }
}

const ModalPortal = ({children, options}: IModalPortalProps) => {

    const element =  useMemo(() => {
        return document.createElement('div')
    }, [])

    useEffect(() => {

        if (modalRootElement) {
            if(options.statusModal) {
                modalRootElement.appendChild(element)

                return () => {
                    modalRootElement.removeChild(element)
                }
            }
        }
    })



    useEffect(() => {
        if (options.statusModal) {
            document.body.style.overflow = 'hidden'
        }
        if (options.statusModal) {
            return () => {
                document.body.style.overflow = 'auto'
            }
        }

    }, [options.statusModal])

    if (options.statusModal) {
        return createPortal(<Modal options={options}>{children}</Modal>, element)
    } else {
        return null
    }


};

export default ModalPortal;